import { AIAssistantToolNames } from 'balus-common';
import { isToolUIPart, type UIMessage } from 'ai';

// 既存ビューを対象に取るツールだけを見る。addView は新規ビューなので、光らせる対象がまだ存在しない。
const TARGET_TOOL_TYPES: string[] = [`tool-${AIAssistantToolNames.patchView}`];

/**
 * 入力生成中・実行待ちのツール呼び出しから、AIが触ろうとしているビューIDを取り出す。
 * input-streaming 中の入力は生成途中のJSONなので、取り出せた分だけを返す。
 */
export function extractAIWorkingViewIds(messages: readonly UIMessage[]): string[] {
  const lastMessage = messages.at(-1);
  if (lastMessage?.role !== 'assistant') return [];

  const viewIds = new Set<string>();
  for (const part of lastMessage.parts ?? []) {
    if (!isToolUIPart(part)) continue;
    if (!TARGET_TOOL_TYPES.includes(part.type)) continue;
    if (part.state !== 'input-streaming' && part.state !== 'input-available') continue;

    for (const viewId of viewIdsOf(part.input)) viewIds.add(viewId);
  }

  return [...viewIds];
}

function viewIdsOf(input: unknown): string[] {
  if (typeof input !== 'object' || input === null) return [];

  const views = (input as { views?: unknown }).views;
  if (!Array.isArray(views)) return [];

  return views
    .map((view) => (typeof view === 'object' && view !== null ? (view as { id?: unknown }).id : undefined))
    .filter((id): id is string => typeof id === 'string' && id.length > 0);
}
